// extracted by mini-css-extract-plugin
module.exports = {"Table":"Table_Table__2MTZt","Break":"Table_Break__3MR4Z","Row":"Table_Row__2cv2k"};